export default "__VITE_ASSET__2163fa2c__"